import { getApiEndpoint } from '../config/api.js';

export interface ThemeItem {
  theme: string;
  summary?: string;
  relevance: number; // 0..1
  sentiment: 'positive' | 'neutral' | 'negative';
}

export interface ThemesDiscoverResponse {
  themes: ThemeItem[];
  lastUpdated: string;
}

export interface ThemeAnalysisDetail {
  theme: string;
  sentiment: 'positive' | 'neutral' | 'negative';
  summary: string;
  risks: Array<{ title: string; summary: string; significance?: number }>;
  trends: Array<{ title: string; summary: string; significance?: number }>;
  regulatory: Array<{ title: string; summary: string; significance?: number }>;
  lastUpdated: string;
}

export const themesApi = {
  async discover(profileId: string): Promise<ThemesDiscoverResponse> {
    const base = getApiEndpoint();
    const url = new URL(
      `${base}/profile/${encodeURIComponent(profileId)}/themes`
    );
    url.searchParams.set('action', 'discover');
    const res = await fetch(url.toString());
    if (!res.ok) throw new Error(`Themes discover failed: ${res.status}`);
    const json = await res.json();
    return json.data as ThemesDiscoverResponse;
  },

  async analyze(profileId: string, theme: string): Promise<ThemeAnalysisDetail> {
    const base = getApiEndpoint();
    const url = new URL(
      `${base}/profile/${encodeURIComponent(profileId)}/themes`
    );
    url.searchParams.set('action', 'analyze');
    url.searchParams.set('theme', theme);
    const res = await fetch(url.toString());
    if (!res.ok) throw new Error(`Theme analysis failed: ${res.status}`);
    const json = await res.json();
    return json.data as ThemeAnalysisDetail;
  },
};
